export const SET_AUTOCOMPLETE = "SET_AUTOCOMPLETE";